<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-7"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [-1, 20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
        >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="96" v-if="userId === null">
          <v-container fluid>
            <v-row>
                <v-text-field
                    v-model="searchTerm"
                    label="Search user"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-checkbox
                    v-if="userId === null"
                    v-model="deletedFilter"
                    label="Show only not deleted"
                    @change="onUpdateFilters"
                ></v-checkbox>
              <v-spacer></v-spacer>
              <PayedNewEditDialog></PayedNewEditDialog>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.edit="{ item }">
        <PayedNewEditDialog :item="item"></PayedNewEditDialog>
      </template>
      <template v-slot:item.deleted="{ item }">
        <BaseDeletedCheckBox :value.sync="item.deleted" @change="onDelete(item)"></BaseDeletedCheckBox>
      </template>
      <template v-slot:item.icon="{ item }">
        <v-icon v-if="item.payed < 0">mdi-timer-outline</v-icon>
        <v-icon v-if="item.payed > 0">mdi-cash</v-icon>
      </template>
      <template v-slot:item.paid="{ item }">
        <span v-if="item.payed > 0">{{item.payed}}</span>
      </template>-
       <template v-slot:item.extra_hours="{ item }">
        <span v-if="item.payed < 0">{{-item.payed}}</span>
      </template>
      <template v-slot:item.calendar_date_user__calendar_date__dt="{ item }">
        <span v-if="item.calendar_date_user">{{ item.calendar_date_user.calendar_date.dt | moment("DD.MM.YYYY") }}</span>
      </template>
      <template v-slot:item.calendar_date_user__human_user__user="{ item }">
        <span v-if="item.calendar_date_user">{{ item.calendar_date_user.human_user.user }} ({{ item.calendar_date_user.human_user.employee_number }})</span>
      </template>
      <template v-slot:item.created_on="{ item }">
        <span v-if="item.created_on">{{ item.created_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.edited_on="{ item }">
        <span v-if="item.edited_on">{{ item.edited_on | moment("DD.MM.YYYY HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.created_by="{ item }">
        <span v-if="item.created_by">{{ item.created_by.username }}</span>
      </template>
      <template v-slot:item.edited_by="{ item }">
        <span v-if="item.edited_by">{{ item.edited_by.username }}</span>
      </template>
    </v-data-table>
    <PayedConfirmDialog store-name="Contract"></PayedConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import PayedNewEditDialog from "@/components/TimeTracker/PayedNewEditDialog";
import PayedConfirmDialog from "@/components/TimeTracker/PayedConfirmDialog";
import BaseDeletedCheckBox from "@/components/Base/BaseDeletedCheckBox";

export default {
  name: 'Payed',
  props: {
    subtractHeight: {type: [Number], default: 250},
    // 64 - header height, 24 - table padding (12 for top + 12 for bottom), 59 - table footer height, 36 - page footer height.
    height: {type: [Number], default: window.innerHeight},
    userId: {type: [Number], default: null},
  },

  components: {
    PayedNewEditDialog,
    PayedConfirmDialog,
    BaseDeletedCheckBox,
  },

  computed: {
    ...mapGetters('HRPayed', ['getColumns']),
    ...mapFields('HRPayed', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),
  },
  watch: {
  },

  methods: {
    ...mapActions('HRPayed', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),
    ...mapActions('HumanUser', {fetchItemListHuman: 'fetchItemList'}),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.payed > 0)
        return "light-blue lighten-4"
      if (item.payed < 0)
        return "green lighten-4"
      else
        return null
    },

    onDelete(item) {
      console.log('onDelete', item)
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: {deleted: item.deleted},
        dto_model: {to_consumer: this.dto_model, from_consumer: this.dto_model}
      })
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}
      if (this.userId != null)
        this.filters = {user_id: this.userId}
      if (this.deletedFilter)
        this.filters['not_deleted'] = true
      else
        this.filters['not_deleted'] = null
      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    this.searchTerm = null
    this.onUpdateFilters()
    if (this.itemListHuman.length === 0)
      await this.fetchItemListHuman({to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'})
  },

  data() {
    return {
      dto_model: 'PayedEventDTO',
      onlyActiveUser: true,
      localFilterDate: this.date,
      userSelected: null,
      filterEvents: [],
      errorMessageFilter: false,
      uncheckedFilter: false,
      deletedFilter: true,
      startMonth: null,
      endMonth: null,
      windowSize: {x: 0, y: 0,},
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
